export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/export-02c257646db71f705375244f420a07ec.svg";